export enum AccessesKeyEnum {
  MAIN_DASHBOARD_ALL = "main_dashboard:all",
  PAYMENT_ALL = "payment:all",
  POS_ALL = "pos:all",
  ORDER_VIEW = "order:view",
  ORDER_ACTION = "order:action",
  PRODUCT_VIEW = "produk:view",
  PRODUCT_ACTION = "produk:action",
  STOCK_VIEW = "stock:view",
  STOCK_ACTION = "stock:action",
  REPORT_LIST_ALL = "reports_list:all",
  PRICE_MONITORING_ALL = "price_monitoring:all",
  CATALOG_ALL = "catalog:all",
  PROMOTION_ALL = "promotion:all",
  PRODUCT_COLLECTION_VIEW = "product_collection:view",
  PRODUCT_COLLECTION_ACTION = "product_collection:action",
  MARKETPLACE_CONNECTION_VIEW = "marketplace_connection:view",
  MARKETPLACE_CONNECTION_ACTION = "marketplace_connection:action",
  BANK_ACCOUNT_INFORMATION_ALL = "bank_account_information:all",
  SHOP_MONITORING_ALL = "shop_monitoring:all",
  TERM_OF_PAYMENT_ALL = "term_of_payment:all",
  SALESPERSON_ALL = "salesperson:all",
  SETTINGS_ORDER_APPROVAL_ALL = "settings_order_approval:all",
  VIRTUAL_BUNDLING_VIEW = "virtual_bundling:view",
  VIRTUAL_BUNDLING_ACTION = "virtual_bundling:action",
  WAREHOUSE_VIEW = "warehouse:view",
  WAREHOUSE_ACTION = "warehouse:action",
  VOUCHER_VIEW = "voucher:view",
  VOUCHER_ACTION = "voucher:action",
  CONSIGNMENT_DELIVERY_VIEW = "consignment_delivery:view",
  CONSIGNMENT_DELIVERY_ACTION = "consignment_delivery:action",
  CUSTOMER_STOCK_VIEW = "customer_stock:view",
  CUSTOMER_STOCK_ACTION = "customer_stock:action",
  INVOICE_DATA_VIEW = "invoice_data:view",
}

export default AccessesKeyEnum;
